<template>
  <div class="uploader" :class="className">
    <el-upload ref="uploaderImage" class="uploader-image" action="" accept="video/*" :show-file-list="false" :on-change="handlePushUploader" :auto-upload="false" :disabled="disabled">
      <div v-if="url" style="width: 320px;">
        <video id="player-container" ref="customVideo" :src="url" class="custom-video" preload="auto" controls playsinline webkit-playsinline style="width: 270px;" />
        <div v-if="showReplace" class="link-color" style="margin-top:10px;font-size:14px;">重新上传</div>
      </div>
      <i v-else class="el-icon-plus plus-push" />
    </el-upload>
    <el-progress v-if="
      uploadProgress != 0 &&
        uploadProgress != 100 &&
        uploadProgressStatus
    " class="progress-cont" :text-inside="true" :stroke-width="16" :percentage="uploadProgress" />
    <div v-if="title" class="tip">{{ title }}</div>
    <!-- <p class="uploader-info">支持上传*.mov、*.mp4格式</p>
    <p class="uploader-info">大小不超过{{ limitSize }}M</p>
    <p v-if="sizeTips" class="uploader-info">尺寸：{{ sizeTips }}</p>
    <p v-if="breadth" class="uploader-info">宽度：{{ breadth }}</p> -->
  </div>
</template>

<script>
import { getFileType } from '@/common/js/util';

export default {
  name: 'UpdateImage',
  props: {
    className: {
      type: String,
      default: '',
    },
    showReplace: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    sizeTips: {
      type: String,
      default: '',
    },
    breadth: {
      type: String,
      default: '',
    },
    limitSize: {
      type: Number,
      default: 20,
    },
    savePath: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: Number,
      default: 15,
    },
  },
  data() {
    return {
      uploadProgressStatus: false,
      uploadProgress: 0,
    };
  },
  methods: {
    handlePushUploader(file) {
      this.uploader(file);
    },
    uploader(file) {
      const _this = this;
      if (getFileType(file.raw.name) !== 'video') {
        this.$message.error('视频格式不正确');
        this.$refs.uploaderImage.clearFiles();
        return;
      }
      if (this.limitSize && parseFloat(file.raw.size / 1024 / 1024) > this.limitSize) {
        this.$message.error(`视频大小不能超过${this.limitSize}M`);
        this.$refs.uploaderImage.clearFiles();
        return;
      }
      this.asyncImgChecked(file);
    },
    asyncImgChecked(file) {
      const _this = this;
      if (this.sizeTips) {
        const width = parseInt(this.sizeTips.split(':')[0]);
        const height = parseInt(this.sizeTips.split(':')[1]);
        const videoElement = document.createElement('video');
        videoElement.addEventListener('loadedmetadata', function (_event) {
          const vwidth = videoElement.videoWidth;
          const vheight = videoElement.videoHeight;
          const duration = videoElement.duration;
          if (_this.duration < duration) {
            _this.$message.error(`视频时长不能超过${_this.duration}s`);
            _this.$refs.uploaderImage.clearFiles();
            return;
          }
          const valid = (vwidth / vheight) === (width / height);
          if (valid) {
            _this.uploadProgressStatus = true;
            _this.$Api.uploadFile.putCloudDemandUpload({
              mediaFile: file.raw,
              onUploadProgress: progressEvent => {
                const process =
                  parseInt((progressEvent.loaded / progressEvent.total) * 100) || 0;
                _this.uploadProgress = process;
              },
            }).then(data => {
              _this.uploadProgressStatus = false;
              _this.$emit('upload', data.mediaUrl);
            });
          } else {
            _this.$message.error(`视频宽高比必须是${_this.sizeTips}`);
            _this.$refs.uploaderImage.clearFiles();
          }
        });
        const _URL = window.URL || window.webkitURL;
        try {
          videoElement.srcObject = file.raw;
        } catch (error) {
          videoElement.src = _URL.createObjectURL(file.raw);
        }
      } else {
        _this.uploadProgressStatus = true;
        _this.$Api.uploadFile.putCloudDemandUpload({
          mediaFile: file.raw,
          onUploadProgress: progressEvent => {
            const process =
              parseInt((progressEvent.loaded / progressEvent.total) * 100) || 0;
            _this.uploadProgress = process;
          },
        }).then(data => {
          _this.uploadProgressStatus = false;
          _this.$emit('upload', data.mediaUrl);
        });
      }
    },
  },
};
</script>

<style lang="less" >
.uploader {
  margin-right: 30px;
  white-space: nowrap;

  .uploader-image {
    .el-upload {
      border: 1px dashed #d9d9d9;
      background: #f7f7f7;
      width: 150px;
      height: 150px;
      text-align: left;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      // overflow: hidden;
      font-size: 12px;
      line-height: 20px;
      color: #bbbbbb;
    }

    .el-upload:hover {
      border-color: #c1c1c1;
    }

    .el-icon-plus {
      font-size: 32px;
      color: #8c939d;
      width: 150px;
      height: 150px;
      line-height: 150px;
      text-align: center;
    }
    .uploader-img {
      width: 100%;
      height: 100%;
      // width: 150px;
      // height: 150px;
      display: block;
      object-fit: contain;
    }
  }
  .uploader-info {
    color: #bbbbbb;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
